import moment from 'moment';
import Uuid from '../../../../support/Uuid';
import { isArray } from 'lodash';

class ComprobanteNominaInputPipe {
  getName() {
    return 'nomina';
  }

  apply(data, comprobante) {
    if (!comprobante.isNomina()) {
      return data;
    }

    const { Complemento } = data;

    if (!Complemento || !Complemento.Nomina) {
      throw new Error('El comprobante no contiene el complemento de Nómina.');
    }

    let { Nomina } = Complemento;

    if (isArray(Nomina)) {
      Nomina = Nomina.pop();
    }

    if (!!Nomina.Percepciones) {
      Nomina.Percepciones = {
        ...Nomina.Percepciones,
        Percepcion: Nomina.Percepciones.Percepcion.map((value) => {
          if (!!value.HorasExtra) {
            value = {
              ...value,
              HorasExtra: value.HorasExtra.map((extra) => {
                return {
                  id: Uuid.v4(),
                  ...extra,
                };
              }),
            };
          }

          return {
            id: Uuid.v4(),
            ...value,
          };
        }),
      };
    }

    if (!!Nomina.Deducciones) {
      Nomina.Deducciones = {
        ...Nomina.Deducciones,
        Deduccion: Nomina.Deducciones.Deduccion.map((value) => {
          return {
            id: Uuid.v4(),
            ...value,
          };
        }),
      };
    }

    if (!!Nomina.OtrosPagos) {
      Nomina.OtrosPagos = {
        OtroPago: Nomina.OtrosPagos.OtroPago.map((value) => {
          return {
            id: Uuid.v4(),
            ...value,
          };
        }),
      };
    }

    if (!!Nomina.Incapacidades) {
      Nomina.Incapacidades = {
        ...Nomina.Incapacidades,
        Incapacidad: Nomina.Incapacidades.Incapacidad.map((value) => {
          return {
            id: Uuid.v4(),
            ...value,
          };
        }),
      };
    }

    delete Complemento.Nomina;

    data.Nomina = {
      ...Nomina,
      FechaPago: moment(Nomina.FechaPago).toDate(),
      FechaInicialPago: moment(Nomina.FechaInicialPago).toDate(),
      FechaFinalPago: moment(Nomina.FechaFinalPago).toDate(),
    };

    data.Receptor = {
      ...data.Receptor,
      nomina: {
        ...Nomina.Receptor,
      },
    };

    return data;
  }
}

export default ComprobanteNominaInputPipe;
